import { render, staticRenderFns } from "./listInstrucao.vue?vue&type=template&id=256ef754&scoped=true&"
import script from "./listInstrucao.vue?vue&type=script&lang=js&"
export * from "./listInstrucao.vue?vue&type=script&lang=js&"
import style0 from "./listInstrucao.vue?vue&type=style&index=0&id=256ef754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ef754",
  null
  
)

export default component.exports